import { SortingOrder } from "@shared/types";

export const getTableOnChangeFunction = <T>(
  sortBy: T | undefined,
  setSortBy: (sortBy: T) => void,
  sortDirection: SortingOrder,
  setSortDirection: (sortDirection: SortingOrder) => void,
  fieldNameToSortMapping: Record<string, T>,
  oppositeSorts?: T[]
) => {
  return (_pagination: any, _filters: any, sorter: any) => {
    const sort =
      fieldNameToSortMapping[
        sorter.field as keyof typeof fieldNameToSortMapping
      ];
    let direction =
      sorter.order === "descend" ? SortingOrder.DESCEND : SortingOrder.ASCEND;
    if (sort !== sortBy || direction !== sortDirection) {
      if (sort !== undefined) setSortBy(sort);
      if (sort !== sortBy && oppositeSorts?.includes(sort)) {
        direction = SortingOrder.DESCEND;
      }
      setSortDirection(direction);
    } else if (!sorter.column && sort === sortBy) {
      setSortDirection(-1 * sortDirection);
    }
  };
};
